import React from "react";

import * as Styles from "./styles";

interface Props {
  data: any;
  value: any;
  onChange: (value: string[]) => void;
}

const ToggleBtnsColors: React.FC<Props> = ({ data, value, onChange }) => {
  const handleValues = (
    event: React.MouseEvent<HTMLElement>,
    newValues: string[]
  ) => {
    onChange(newValues);
  };

  return (
    <Styles.FormTag value={value} onChange={handleValues}>
      {data?.map((item: any) => (
        <Styles.LabelTag
          background={item.background}
          value={item.value}
          key={item.value}
        >
          {item.label || "---"}
        </Styles.LabelTag>
      ))}
    </Styles.FormTag>
  );
};

export default ToggleBtnsColors;
